import React from "react";
import {
	Route,
	Switch,
	BrowserRouter as Router,
	withRouter,
} from "react-router-dom";
import { Redirect } from "react-router-dom";
import { createBrowserHistory } from "history";
import { Menu } from "antd";
import Registry from "./component-registry";
import _isArray from "lodash/isArray";
import routes from "./routes.config.json";
// import { AuthRouteWrapper } from "./auth";

export const history = createBrowserHistory();

const buildRoutes = (routes) => {
	return routes.map(
		({
			component,
			key = null,
			group = false,
			label,
			path,
			exact,
			children,
			actions=[],
			search,
			requiresAuth=true,
			props: routeProps = null
		}) => {
			// console.log("routeProps", routeProps)
			if (_isArray(children) && children.length) {
				let RouteComponent = React.Fragment;
				if (!group) RouteComponent = Registry.getComponent(component);
				class SubRoutes extends React.Component {
					render() {
						return (
							<RouteComponent
								{...this.props}
								childRoutes={children}
								label={label}
								path={path}
								actions={actions.map(_ => {
									if(_.component) {
										return {
											..._,
											component: Registry.getComponent(_.component),
										};
									}
									return _
								})}
								search={search ? Registry.getComponent(search) : null}
							>
								{buildRoutes(children)}
							</RouteComponent>
						);
					}
				}
				if(requiresAuth) SubRoutes = SubRoutes
				return (
					<Route
						key={key || label}
						path={path}
						exact={exact}
						component={SubRoutes}
					/>
				);
			}
			if (component === "redirect") {
				return <Redirect key={path} to={path} />;
			}
			let RouteComponent = Registry.getComponent(component);
			if(requiresAuth) RouteComponent = RouteComponent;
			
			return (
				<Route
					key={key || label}
					path={path}
					exact={exact}
					render={props => <RouteComponent {...props} routeProps={routeProps} />}>
				</Route>
			);
		}
	);
};

const buildMenu = (routes) => {
	return routes.filter(_ => _.hidden !== true).map(
		({ group = false, route=false, label, path, menu = true, icon, children }) => {
			let IconComp = null;
			if (icon) {
				IconComp = Registry.getIcon(icon);
			}
			if (menu && group && _isArray(children) && children.length) {
				let MenuGroupItem = !route ? Menu.ItemGroup : Menu.SubMenu;
				// if (group) MenuGroupItem = Menu.SubMenu;
				return (
					<MenuGroupItem
						key={path}
						title={label}
						icon={IconComp ? <IconComp /> : null}
					>
						{buildMenu(children)}
					</MenuGroupItem>
				);
			}

			return (
				<Menu.Item
					theme={"dark"}
					key={path}
					icon={IconComp ? <IconComp /> : null}
					mode="inline"
					defaultopenkeys={[]}
				>
					{label}
				</Menu.Item>
			);
		}
	);
};

function Routes(Comp, props) {
	return (
		<Comp 
			routes={routes} 
			{...props}>
			<Switch>
				{buildRoutes(routes)}
			</Switch>
		</Comp>
	);
}

class RoutesMenuComponent extends React.Component {
	state = {
		routeKey: null,
	};
	componentDidMount() {
        const currentPath = this.props.location.pathname;

		let existingRoute = routes.find((_) => {
            if(_.group && !_.route) {
                const childRoutes = _.children?.some(_ => _.path === currentPath);
                if(childRoutes && childRoutes.length) return childRoutes;
            } 
            if(!_.group && _.route) { 
                return currentPath.includes(_.path);
            }
			return _.path === currentPath;
		});
		if (existingRoute && existingRoute.group && existingRoute.children) {
			existingRoute = existingRoute.children.find(
				(_) => _.path === currentPath
			);
		}
		if (existingRoute) {
			return this.setState({
				routeKey: existingRoute.path,
			});
		} else {
			let baseRoute = routes.find((_) => _.default);
			if (baseRoute) {
				baseRoute = routes[0];
			}
			if (baseRoute && currentPath === "/")
				return this.props.history.replace(baseRoute.path);
		}

		
	}

	onClick = ({ item, key, keyPath }) => {
		this.setState(
			{
				routeKey: key,
			},
			() => {
				this.props.history.replace(key);
			}
		);
	};
	render() {
		return (
			<Menu
				theme="light"
				mode="inline"
				selectedKeys={[this.state.routeKey]}
				onClick={this.onClick}
			>
				{buildMenu(routes)}
			</Menu>
		);
	}
}

export const RoutesMenu = withRouter(RoutesMenuComponent);

export const RouterWrapper = (props) => <Router basename="/backoffice/app">{props.children}</Router>;

export default Routes;
